export const BLOCKED_EXTENSIONS = [
  {
    extName: 'READ_WRITE_EXTN', // Read&Write for Google Chrome™
    identifyBy: () => document.getElementsByTagName('th-rw4gc'),
  },
]
